import $ from 'jquery'
import Gallery from "blueimp-gallery";
import { updateAffix } from './affix-fafix'
import { updateImageDisplays } from './image-displays'
import { trace } from 'rytm-helpers';

let s = false;

// ### toggle class of <html> element
const onToggleClass = (e) => {
  console.log("toggle class")
  e.preventDefault();
  const btn = e.currentTarget;
  const className = btn.dataset.toggleClass;
  if (className) {
    document.documentElement.classList.toggle(className);
  }
}
const onBlueimpGalleryLinkClick = (e) => {
  e.preventDefault();
  let blueimpLinks = document.querySelectorAll('[data-gallery]');  
  let selector = e.currentTarget.getAttribute('data-gallery');
  trace("blueimp gallery selector", selector)
  if (!selector) {
    return
  }
  let link = e.currentTarget;
  let options = {
    container: selector,
    event: e,
    index: link
  }
  Gallery(blueimpLinks, options);
}

const onDismissAllClasses = (e) => {
  e.preventDefault();
  let classes = []
  const list = [...document.querySelectorAll('[data-toggle-class]')]
  list.forEach((el) => {
    const classN = el.dataset.toggleClass
    if (classes.indexOf(classN) < 0) {
      classes.push(classN)
    }
  })
  classes.forEach((className) => {
    document.documentElement.classList.remove(className);
  })
}

// ### Window update
let windowUpdateTimer = false;
export const windowUpdate = (e) => {
  updateAffix()
  clearTimeout(windowUpdateTimer)
  windowUpdateTimer = setTimeout(() => {
    updateImageDisplays()
  }, 200)
};

// ### is Mobile?
const isMobile = () => window.innerWidth < 992;

// scroll to position
export const scrollToPos = (topPx, time = 800, callback = null)=> {
  let $page = $('html, body');
  $page.animate({ scrollTop: topPx }, time, ()=>{
    if($.isFunction(callback)){
      callback()
    }
  });  
}

// Scroll to $target
export const scrollTo = ($target, offset = 0, time = 800, callback = null)=> {
  if (!$target.length) {
    return false;
  }
  let topPx = $target.offset().top - offset;
  scrollToPos(topPx, time, callback);
}

// ### INIT
export const initCommon = () => {
  // initSiv({ singleShotMode: false });
  $('body').on('click', '*[data-toggle-class]', onToggleClass);
  $('body').on('click', '.dismiss-all', onDismissAllClasses);
  $('body').on('click', 'a[data-gallery]', onBlueimpGalleryLinkClick);
  $(document).on('DOMContentLoaded load', windowUpdate);
  $(window).on('resize', windowUpdate);
  windowUpdate();  
};